import { close as navExternalClose } from '../nav-external'

function init() {
  const button = document.querySelector('#nav-toggle')

  if (!button) {
    return
  }

  button.addEventListener('click', (e) => {
    e.preventDefault()
    document.body.classList.toggle('has-navigation')
    navExternalClose()
  })
}

export default init
